module.exports = __webpack_public_path__ + "img/SK.708d91c9.svg";